//Class
import { DiscussionCharacter } from "../../model/discussionCharacter";

//Images
import marinaImg from "./images/marina.png";
import joannaImg from "./images/joanna.png";
import theFluffImg from "./images/theFluff.png";
import inoahImg from "./images/inoah.png";
import creamyImg from "./images/creamy.png";
import tomasImg from "./images/tomas.png";
import floraImg from "./images/flora.png";
import laurenImg from "./images/lauren.png";
import zoloImg from "./images/zolo.png";
import edgarImg from "./images/edgar.png";
import bobbiSueImg from "./images/bobbiSue.png";
import zingoImg from "./images/zingo.png";
import croissantImg from "./images/croissant.png";
import sallyImg from "./images/sally.png";

const discussionCharacters = {
  marina: new DiscussionCharacter("Marina", marinaImg),

  joanna: new DiscussionCharacter("Joanna", joannaImg),

  theFluff: new DiscussionCharacter("The Fluff", theFluffImg),

  inoah: new DiscussionCharacter("Inoah", inoahImg),

  creamy: new DiscussionCharacter("Creamy", creamyImg),

  tomas: new DiscussionCharacter("Tomas", tomasImg),

  flora: new DiscussionCharacter("Flora", floraImg),

  lauren: new DiscussionCharacter("Lauren", laurenImg),

  zolo: new DiscussionCharacter("Zolo", zoloImg),

  edgar: new DiscussionCharacter("Edgar", edgarImg),

  bobbiSue: new DiscussionCharacter("Bobbi Sue", bobbiSueImg),

  zingo: new DiscussionCharacter("Zingo", zingoImg),

  croissant: new DiscussionCharacter("Croissant", croissantImg),

  sally: new DiscussionCharacter("Sally", sallyImg),
};

export default discussionCharacters;
